/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Page Layout.
 */

import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";
import { NavBar } from "./navigation/desktop/NavBar";
import { PageFooter } from "./footer/desktop/PageFooter";

function PageLayout({ children }) {
    const { isLoading, isAuthenticated } = useAuth0();
    const location = useLocation();
    const isHomeUnauthenticated = location.pathname === "/" && !isAuthenticated;

    return (
        <div
            style={{
                fontFamily: "Overpass, Overpass-Regular, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
                WebkitFontSmoothing: "antialiased",
                MozOsxFontSmoothing: "grayscale",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#ffffff",
                color: "#0f172a"
            }}
        >
            {/* Skip link for a11y */}
            <a
                href="#main"
                style={{
                    position: "absolute",
                    left: "-9999px",
                    top: "auto",
                    width: "1px",
                    height: "1px",
                    overflow: "hidden"
                }}
                onFocus={(e) => {
                    // reveal on focus
                    Object.assign(e.currentTarget.style, {
                        left: "16px",
                        top: "12px",
                        width: "auto",
                        height: "auto",
                        padding: "6px 10px",
                        background: "#000",
                        color: "#fff",
                        borderRadius: "8px",
                        zIndex: 1000
                    });
                }}
                onBlur={(e) => {
                    // hide again
                    Object.assign(e.currentTarget.style, {
                        left: "-9999px",
                        top: "auto",
                        width: "1px",
                        height: "1px",
                        padding: 0,
                        background: "transparent",
                        color: "inherit",
                        borderRadius: 0,
                        zIndex: "auto"
                    });
                }}
            >
                Skip to content
            </a>

            {/* Header / Nav - hide on home when not authenticated to avoid flash before Auth0 redirect */}
            {!isLoading && !isHomeUnauthenticated && <NavBar />}

            {/* Main content container */}
            <main
                id="main"
                role="main"
                style={{
                    flex: "1 0 auto",
                    maxWidth: "1850px",
                    margin: "0 auto",
                    padding: "0 16px",
                    width: "100%"
                }}
            >
                {children}
            </main>

            {/* Footer (full width) - hide on home when not authenticated for consistent transition */}
            {!isHomeUnauthenticated && <PageFooter />}
        </div>
    );
}

export default PageLayout;
export { PageLayout };
